<template>
  <div class="entry-main-wrapper">
    <DataLoader :is_on="fetching" />
    <div class="entry-wrapper">
      <div class="entry-header">
        <div class="entry-header-left">
          <div class="entry-icon">
            <img src="@/assets/img/novi_predmet.svg" />
          </div>
          <div class="entry-title">{{naziv_forme}}</div>
        </div>
        <div class="entry-header-right">
          <a @click="goBack()" class="entry-exit"
            ><img src="@/assets/img/entry_form_close.svg"
          /></a>
        </div>
      </div>
      <!-- end new case header -->
      <div class="main-entry-form-wrapper">
        <!-- *** VRSTA DOGAĐAJA **** -->
        <form-drop-down
          :label="$t('forms.event.type_lbl')"
          id="vrsta-dogadaja"
          ref="vrstaDogadaja"
          :dropImport="event_type_list"
          :disabled="is_edit"
        ></form-drop-down>
        <!-- NASLOV DOGAĐAJA -->
        <form-input
          :label="$t('forms.event.naslov_lbl')"
          id="naslov-dogadaja"
          ref="naslovDogadaja"
          required="required"
          :invalid="is_invalid.naslov"
        ></form-input>
        <!-- STATUS -->
        <form-drop-down
          :label="$t('forms.event.status_lbl')"
          id="status-dogadaja"
          ref="statusDogadaja"
          :dropImport="statusi_dogadaja"
        ></form-drop-down>
        <!-- Datum događaja -->
        <div class="events-date-time-wrapper">
          <div class="form-input-wrapper">
              <label class="form-label" for="vrijeme-pocetka">
                  <span>{{event_object.event_type.ID == 1 || event_object.event_type.ID == 4 ? $t('forms.event.rok1_lbl') : $t('forms.event.rok2_lbl')}}</span>
              </label>
                  <input
                  :class="['form-input', 'date-input', is_invalid.datum ? 'invalid':'']"
                  :style="today_date == '' ? 'color:#777777' :''"
                  type="date"
                  id="datum-pocetka"
                  ref="datumPocetka"
                  name="datum-pocekta"
                  v-model="today_date"
                  />
          </div>
          <!-- CIJELI DAN -->
          <form-checkbox v-show="event_object.event_type.ID == 2 || event_object.event_type.ID == 3" class="checkbox" :id="'cijeli-dan'" :name="'cijeli-dan'" :label="$t('forms.event.cijeli_lbl')" ref="cijeliDan"></form-checkbox>
        </div> 
        <!-- ZAVRŠETAK DOGAĐAJA -->
        <div v-show="event_object.event_type.ID == 2 || event_object.event_type.ID == 3" class="form-time-input-wrapper">
          <div class="form-time-wrapper">
            <label class="form-label" for="vrijeme-pocetka">
                <span>{{ $t('forms.event.vrije_poc') }}</span>
            </label>
            <div :class="['timepicker', 'timepicker1', is_invalid.datum_zavrsetka ? 'invalid':'']" dir="ltr" @click="addFocus(0,$event)">
              <div> 
                <input type="text" id="pocetak" class="hh N form-input time-input" min="0" max="23" placeholder="hh" maxlength="2" ref="dt_st_hh"/>:
                <input type="text" id="switch-from" class="mm N form-input time-input" min="0" max="59" placeholder="mm" maxlength="2" ref="dt_st_mm"/>
              </div>
              <v-menu
                ref="vrijemePocetkaChooser"
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="20"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div
                    :class="[is_invalid.datum_zavrsetka ? 'invalid':'', 'time-sv']"
                    color="time-custom"
                    v-bind="attrs"
                    v-on="on"
                    @click="menu1 = !menu1"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="16"
                      viewBox="0 0 15 16"
                    >
                      <g>
                        <g>
                          <path
                            fill="#606076"
                            d="M15 7.765A7.476 7.476 0 1 1 7.524.289 7.484 7.484 0 0 1 15 7.765zM8.058 3.493a.534.534 0 0 0-1.068 0v3.738H3.252a.534.534 0 0 0 0 1.068h4.272a.534.534 0 0 0 .534-.534z"
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                </template>
                  <v-time-picker
                    v-if="menu1"
                    v-model="dt_start_chooser"
                    full-width
                    format="24hr"
                    scrollable
                    color="time-custom"
                  ></v-time-picker>
              </v-menu>
            </div>
          </div>
          <div class="form-time-wrapper"  v-show="!event_object.all_day.value">
            <label class="form-label" for="vrijeme-zavrsetak">
                <span>{{ $t('forms.event.vrije_zavr') }}</span>
            </label>
            <div :class="['timepicker', 'timepicker2', is_invalid.datum_zavrsetka ? 'invalid':'']" dir="ltr" @click="addFocus(1,$event)">
                <div>
                  <input type="text" id="switch-here" class="hh N form-input time-input" min="0" max="23" placeholder="hh" maxlength="2" ref="dt_end_hh"/>:
                  <input type="text" class="mm N form-input time-input" min="0" max="59" placeholder="mm" maxlength="2" ref="dt_end_mm"/>
                </div>
                <v-menu
                  ref="vrijemeZavrsetkaChooser"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="20"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      :class="[is_invalid.datum_zavrsetka ? 'invalid':'', 'time-sv']"
                      color='time-custom'
                      v-bind="attrs"
                      v-on="on"
                      @click="menu2 = !menu2"
                    >          
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="16"
                      viewBox="0 0 15 16"
                    >
                      <g>
                        <g>
                          <path
                            fill="#606076"
                            d="M15 7.765A7.476 7.476 0 1 1 7.524.289 7.484 7.484 0 0 1 15 7.765zM8.058 3.493a.534.534 0 0 0-1.068 0v3.738H3.252a.534.534 0 0 0 0 1.068h4.272a.534.534 0 0 0 .534-.534z"
                          />
                        </g>
                      </g>
                    </svg>
                </div>
                </template>
                  <v-time-picker
                    v-if="menu2"
                    v-model="dt_end_chooser"
                    full-width
                    format="24hr"
                    scrollable
                    color="time-custom"
                  ></v-time-picker>
              </v-menu>
            </div>
          </div>
        </div>
        <!-- ONLINE SASTANAK -->
        <!-- VIDJETI KAK TOCNO PRIKAZATI CIJELI DAN U ODNOSU NA DATUME POCETKA I ZAVRSETKA -->
        <div class="clanovi-tima-wrapper">
          <form-checkbox v-show="event_object.event_type.ID == 2 || event_object.event_type.ID == 3" class="checkbox" :id="'online-sastanak'" :name="'online-sastanak'" :label="$t('forms.event.online')" ref="onlineSastanak"></form-checkbox>
          <form-checkbox v-show="(event_object.event_type.ID == 2 || event_object.event_type.ID == 3) && !is_edit && event_object.is_online.value" class="checkbox" :id="'online-sastanak'" :name="'online-sastanak'" :label="$t('forms.event.mc_soba')" ref="generiraj"></form-checkbox>
        </div>
        <!-- *** URL link za sastanak **** -->
        <form-input
          v-show="event_object.is_online.value && (event_object.event_type.ID == 2 || event_object.event_type.ID == 3)"
          :label="$t('forms.event.outside_url')"
          id="url-link"
          ref="urlLink"
          :invalid="is_invalid.url_link"
          :disabled="generate.value"
        ></form-input>

        <!-- *** BITNOĆA DOGAĐAJA **** -->
        <form-drop-down
          :label="$t('forms.event.importance')"
          id="bitnoca-dogadaja"
          ref="bitnocaDogadaja"
          :dropImport="event_importance_list"
        ></form-drop-down>
        <!-- PODSJETNIK -->
        <!-- <form-slider :id="'podsjetnik'" :name="'podsjetnik'" :edit_value="10" :label="'Podsjeti me prije : '" ref="podsjetnik"></form-slider> -->
        <!-- *** BITNOĆA DOGAĐAJA **** -->
        <form-drop-down
          :label="$t('forms.event.podsjetnik')"
          id="podsjetnik"
          ref="podsjetnik"
          :dropImport="podsjetnici"
        ></form-drop-down> 
        <!-- *** OPIS DOGAĐAJA **** -->
        <form-textarea
          :label="$t('forms.event.napomene')"
          id="opis-dogadaja"
          ref="opisDogadaja"
        ></form-textarea>
          <!-- POGLEDATI ZAKAJ NE PRIKAZUJE MAPU NAKON V-SHOW AKTIVACIJE -->
        <here-map v-show="event_object.event_type.ID == 2 || event_object.event_type.ID == 3" ref="hereMap" :invalid="is_invalid.lokacija_karta">
        </here-map>
        <!-- *** Pojedinosti lokacije **** -->
        <form-textarea
          v-show="event_object.event_type.ID == 2 || event_object.event_type.ID == 3"
          :label="$t('forms.event.location')"
          id="lokacija-sastanka"
          ref="lokacijaSastanka"
        ></form-textarea>
        <form-files-upload 
          :deleted_items.sync="event_object.deleted_privici"
          :existing_items.sync="event_object.privici"
          :new_items.sync="filelist"
          :is_single_upload="false"
        />

        <InvalidElementsList v-if="error_list != 0" :error_list="error_list"/>
        <!-- *** KREIRAJ BUTTON **** -->
        <div :class="{'fixed-to-bottom single':is_edit}">
            <div class="button-create-wrapper">
              <div :class="{'disabled':is_waiting_on_insert}" class="button-default button-create" @click="!is_waiting_on_insert ? validate():''">
                {{naziv_gumba}}
              </div>
            </div>
        </div>
        <v-dialog v-model="warning_unsaved" width="564px">
          <v-card color="universal-vcard">
              <div class="universal-vdialog-title">
                  {{ $t('forms.unsaved_changes') }}
              </div>
              <div class="vdialog-buttons-wrapper">
              <div class="universal-vdialog-button vbutton-secondary" @click="warning_unsaved = false;"> {{ $t("repetitive.cancel") }} </div>
              <div class="universal-vdialog-button vbutton-primary" @click="continueGoBack()"> {{ $t("repetitive.discard") }} </div>
              </div>
          </v-card>
        </v-dialog>
      </div>
      <!-- end main entry form wrapper -->
    </div>
    <!-- end new case wrapper -->
  </div>
  <!-- end new case main wrapper -->
</template>

<script>
import formInput from "@/components/formElements/formInput.vue";
import formDropDown from "@/components/formElements/formDropDown.vue";
import formAutocomplete from "@/components/formElements/formInputAutocomplete.vue";
import formTextarea from "@/components/formElements/formTextarea.vue";
import buttonPersonQuick from "@/components/formElements/buttonPersonQuick.vue";
import formAutocompleteSingle from "@/components/formElements/formAutocompleteSingle.vue";
import formCheckbox from "@/components/formElements/formCheckbox.vue";
import formSlider from "@/components/formElements/formSlider.vue";
import InvalidElementsList from "@/components/generalComponents/InvalidElementsList.vue";
import ms_calendar from "@/apiCallers/promise_handler_db/calendarSharepoint";
import case_management from "@/apiCallers/promise_handler_db/predmeti";
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";
import osobe_pr from "@/apiCallers/promise_handler_db/osobe_pr";
import person from "@/apiCallers/promise_handler_db/person";
import hereMap from "@/components/formElements/hereMap.vue";
import auth from "@/services/auth";
import moment from "moment"
import DataLoader from '@/components/generalComponents/DataLoader'
import FormFilesUpload from '@/components/formElements/formFilesUpload.vue';

import $ from "jquery";
import gsap from "gsap";

export default {
  data() {
	return {
      edit_object : {},
		accessToken : "",
        vrijeme_prije:0,
        first_spis:"",
        today_date:"",
        dt_start:null,
        dt_end:null,
        event_type_list:[],
        spisList:[],
        begin_time:null,
        end_time:null,
        event_importance_list: [],
        statusi_dogadaja:[],
        podsjetnici: this.$t("forms.event.podsjetnici"),
        event_object: {
            event_type: 1,
            title: "",
            body: "",
            begin_timestamp: "1970-01-01T00:00",
            end_timestamp: null,
            is_online: false,
            online_url: "",
            location_name: "",
            event_importance: "normal",
            all_day: false,
            remind_before_minutes: 10,
            selected_team: [],
            location_coords:{lat:-1, lng:-1},
            location_address:"",
            deleted_privici:[],
            privici:[],
        },
        event_type:1,
        error_list:[],
        is_invalid:{
          naslov:false,
          datum:false,
          datum_zavrsetka:false,
          url_link:false,
          naziv_lokacije:false,
          lokacija_karta:false,
        },
        is_waiting_on_insert:false,
        naziv_forme: this.$t("forms.event.naziv_forme_pers1"),
        naziv_gumba: this.$t("forms.event.naziv_gumba1"),
        is_edit:false,
        generate:false,
        fetching:true,
        filelist:[],
        menu1:false,
        menu2:false,
        dt_start_chooser:'',
        dt_end_chooser:'',
        warning_unsaved:false,
	}
  },
  components: {
	  "form-input": formInput,
	  "form-drop-down": formDropDown,
	  "form-autocomplete": formAutocomplete,
	  "button-person-quick": buttonPersonQuick,
	  "form-autocomplete-single": formAutocompleteSingle,
    "form-textarea": formTextarea,
    "here-map": hereMap,
    "form-checkbox": formCheckbox,
    "form-slider": formSlider,
    InvalidElementsList,
    DataLoader,
    FormFilesUpload,
  },
  watch:{
    "event_object.event_type.ID": {
      handler: function (id) {
        if (id == 3 || id == 2) {
          setTimeout(() => {
            this.$refs.hereMap.$data.map.getViewPort().resize()
          }, 100);
        }
      }
    },
    menu1:function(){
      if(this.menu1 && this.$refs.dt_st_hh.value != '' && this.$refs.dt_st_mm.value != ''){
        this.dt_start_chooser = this.$refs.dt_st_hh.value+':'+this.$refs.dt_st_mm.value;
      }
      else{
        if (this.dt_start_chooser != '') {
          let separated = this.dt_start_chooser.split(':');
          this.$refs.dt_st_hh.value = separated[0];
          this.$refs.dt_st_mm.value = separated[1];
          $(".timepicker1")
          .removeClass("invalid")
          .addClass("valid");
        }
      }
    },
    menu2:function(){
      if(this.menu2 && this.$refs.dt_end_hh.value != '' && this.$refs.dt_end_mm.value != ''){
        this.dt_end_chooser = this.$refs.dt_end_hh.value+':'+this.$refs.dt_end_mm.value;
      }
      else{
        if (this.dt_end_chooser != '') {
          let separated = this.dt_end_chooser.split(':');
          this.$refs.dt_end_hh.value = separated[0];
          this.$refs.dt_end_mm.value = separated[1];
          $(".timepicker2")
          .removeClass("invalid")
          .addClass("valid");
        }
      }
    },
  },
  methods: {
    /**
     * Warns user if there are unsaved changes
     * or continues rerouting to previous view
     */
     goBack() {
      if (this.is_edit) {
        this.warning_unsaved = true;
      }
      else{
        this.continueGoBack();
      }
    },
    continueGoBack() {
      this.$router.go(-1);
    },
    addFocus(polje,e){
      if (!e.target.className.includes('time-input')) {
        if (polje == 0) {
          $('#pocetak').focus();
        }
        else{
          $('#switch-here').focus();
        }
      }
    },
    validate(){
      this.error_list = [];
      this.is_invalid={
          naslov:false,
          datum_zavrsetka:false,
          url_link:false,
          naziv_lokacije:false,
          datum:false,
      }
      this.dt_start = this.$refs.dt_st_hh.value+':'+this.$refs.dt_st_mm.value;
      this.dt_end = this.$refs.dt_end_hh.value+':'+this.$refs.dt_end_mm.value;
      if (this.event_object.title.value == "") {
        this.error_list.push(this.$t("forms.event.errors.err1"));
        this.is_invalid.naslov = true;
      }
      if (this.today_date == "") {
        this.error_list.push(this.$t("forms.event.errors.err2"));
        this.is_invalid.datum = true;
      }
      if ((this.event_object.event_type.ID == 2 || this.event_object.event_type.ID == 3) && this.dt_start.split(':').includes('')) {
        this.error_list.push(this.$t("forms.event.errors.err3"));
        this.is_invalid.datum_zavrsetka = true;
      }
      if ((this.event_object.event_type.ID == 2 || this.event_object.event_type.ID == 3) && (this.dt_end.split(':').includes('') || this.dt_start.split(':').includes('') ) && !this.event_object.all_day.value) {
        this.error_list.push(this.$t("forms.event.errors.err4"));
        this.is_invalid.datum_zavrsetka = true;
      }
      if ((this.event_object.event_type.ID == 2 || this.event_object.event_type.ID == 3) && this.dt_end < this.dt_start && !this.event_object.all_day.value) {
        this.error_list.push(this.$t("forms.event.errors.err5"));
        this.is_invalid.datum_zavrsetka = true;
      }
      // if ((this.event_object.event_type.ID == 2 || this.event_object.event_type.ID == 3) && this.event_object.is_online.value == true && this.event_object.online_url.value == "") {
      //   this.error_list.push("Ako je događaj online potrebno je unijeti poveznicu na online događaj");
      //   this.is_invalid.url_link = true;
      // }
      // if ( (this.event_object.event_type.ID == 2 || this.event_object.event_type.ID == 3) && this.event_object.is_online.value == false && this.event_object.location_coords.chosen_location.lat == -1) {
      //   this.error_list.push("Potrebno je odabrati lokaciju na karti");
      //   this.is_invalid.lokacija_karta = true;
      // }
      if (this.error_list.length == 0) {
        this.createEvent();
      }
    },
    async createEvent(){
        const formData = new FormData();
        for (let i = 0; i < this.filelist.length; i++) {
          formData.append("files", this.filelist[i]);
        }
        this.fetching = true;
        this.return_event_object = {
            event_type: parseInt(this.event_object.event_type.ID),
            title: this.event_object.title.value,
            body: this.event_object.body.value,
            begin_timestamp: this.event_object.event_type.ID == 1 || this.event_object.event_type.ID == 4 ? this.today_date+"T20:00" : this.today_date+"T"+this.dt_start,
            end_timestamp: this.event_object.event_type.ID == 1 || this.event_object.event_type.ID == 4 ?  this.today_date+"T20:00" : this.event_object.all_day.value ? this.today_date+"T"+this.dt_start : this.today_date+"T"+this.dt_end,
            is_online: this.event_object.event_type.ID == 1 || this.event_object.event_type.ID == 4 ? false : this.event_object.is_online.value,
            online_url: this.event_object.event_type.ID == 1 || this.event_object.event_type.ID == 4 ? undefined : this.generate.value ? undefined : this.event_object.online_url.value,
            location_name: this.event_object.event_type.ID == 1 || this.event_object.event_type.ID == 4 ? '' : this.event_object.location_name.value,
            event_importance: this.event_object.event_importance.non_int_id,
            all_day: this.event_object.all_day.value,
            remind_before_minutes: parseInt(this.event_object.remind_before_minutes.ID),
            selected_team: this.logged_in_person_data,
            location_address: this.event_object.event_type.ID == 1 || this.event_object.event_type.ID == 4 ? undefined : this.event_object.location_address.lokacijaInput != "" ? this.event_object.location_address.lokacijaInput : undefined,
            location_coords: this.event_object.event_type.ID == 1 || this.event_object.event_type.ID == 4 ? undefined : this.event_object.location_coords.chosen_location.lat != -1 ? {lat: this.event_object.location_coords.chosen_location.lat, lng: this.event_object.location_coords.chosen_location.lng} : undefined,
            planner_buckets_status: this.event_object.bucket_status.ID,
            deleted_privici: this.event_object.deleted_privici,
            existing_privici: this.event_object.privici,
        }
        if (this.is_edit) {
          this.return_event_object.event_id = this.edit_object.graph_id;
          this.return_event_object.event_db_id = this.edit_object.uid
        }
        formData.append("event",JSON.stringify(this.return_event_object));
        formData.append("token", this.accessToken);
        formData.append("person_uid", this.$store.state.logged_in_user.uid);
        console.log(this.return_event_object);
        this.is_waiting_on_insert = true;
        if (!this.is_edit) {
          await ms_calendar.addEventToPersonalCalendar(
              formData
          ).then((response) => {
              this.fetching = false;
                this.is_waiting_on_insert = false;
                console.log(response.data);
                this.$router.push("/kalendar");
              }).catch((err)=>{
                this.fetching = false;
                this.is_waiting_on_insert = false;
              });
        }
        else{
          await ms_calendar.editPersonalEvent(
            formData
          ).then((resp)=>{
            this.fetching = false;
            this.is_waiting_on_insert = false;
            this.$router.push("/kalendar");
          }).catch((err)=>{
            this.fetching = false;
            this.is_waiting_on_insert = false;
          })
        }
    },
    connectEditData(){
      this.$refs.vrstaDogadaja.$data.ID = this.edit_object.event_type.uid;
      this.$refs.naslovDogadaja.$data.value = this.edit_object.title;
      this.$refs.opisDogadaja.$data.value = this.edit_object.body;
      this.$refs.bitnocaDogadaja.$data.non_int_id = this.edit_object.importance_id;
      this.$refs.podsjetnik.$data.ID = this.edit_object.reminder;
      this.event_object.privici = this.edit_object.attachments;
      let start_time = moment(this.edit_object.start_date_time).format("yyyy-MM-DDTHH:mm").split("T");
      let end_time = moment(this.edit_object.end_date_time).format("yyyy-MM-DDTHH:mm").split("T");
      this.today_date = start_time[0];
      this.$refs.statusDogadaja.$data.ID = this.edit_object.planner_buckets_status.id;
      if (this.edit_object.event_type.uid == 1 || this.edit_object.event_type.uid == 4) {
        //
      } else {
        this.$refs.cijeliDan.$data.value = this.edit_object.start_date_time == this.edit_object.end_date_time;
        let start_split_time = start_time[1].split(":");
        let end_split_time = end_time[1].split(":");

        this.$refs.dt_st_hh.value=start_split_time[0]
        this.$refs.dt_st_mm.value=start_split_time[1]
        this.$refs.dt_end_hh.value=end_split_time[0]
        this.$refs.dt_end_mm.value=end_split_time[1]

        this.$refs.onlineSastanak.$data.value = this.edit_object.is_online;
        this.$refs.urlLink.$data.value = this.edit_object.meeting_url;
        if (this.edit_object.coordinates != null) {
          this.$refs.hereMap.setMarkerObject(this.edit_object.coordinates);
          this.$refs.hereMap.$data.lokacijaInput = this.edit_object.location_address;
        }
        this.$refs.lokacijaSastanka.$data.value = this.edit_object.location_name;
      }
      this.fetching=false;
    }
  },

  async created() {
    this.fetching=true;
    this.accessToken = this.$store.state.aToken 
    setTimeout(() => {
      this.$refs.statusDogadaja.$data.ID = 0;
      this.$refs.bitnocaDogadaja.$data.non_int_id = "normal";
      this.$refs.podsjetnik.$data.ID = 5;
      if (this.$store.state.chosen_type != null || this.$store.state.chosen_type != undefined) {
        this.$refs.vrstaDogadaja.$data.ID = this.$store.state.chosen_type;
        this.$store.state.chosen_type = 1;
      }
    }, 10);
    if (this.$store.state.chosen_date != null) {
      this.today_date = this.$store.state.chosen_date;
      this.$store.state.chosen_date = null;
    };
    //Get list of event types
    await ms_calendar.getEventType().then((resp) => {
      resp.data.map((ev)=> ev.uid != 2 && ev.uid != 5 ? this.event_type_list.push({naziv:ev.name, id:ev.uid}):false);
    });
    await ms_calendar.getImportanceTypes().then((resp) => {
      this.event_importance_list = resp.data;
    });
    let lawyer_id = await person.getSelf(this.accessToken);
    this.logged_in_person_data = lawyer_id.data.uid;
    //Get list of event types
    await ms_calendar.getEventBucketStatus().then((resp) => {
      resp.data.map((ev)=>this.statusi_dogadaja.push({naziv:ev.name, id:ev.value}));
      // console.log(resp.data)
    });
    if(this.$route.name == "EditPersonalEvent"){
      this.edit_object = this.$store.state.event_details.chosen_event;
      //za sad ako refresha nek ga vrati
      if (this.edit_object == null) {
        this.continueGoBack();
      }
      this.is_edit = true;
      this.naziv_forme = this.$t("forms.event.naziv_forme_pers_2");
      this.naziv_gumba = this.$t("forms.event.naziv_gumba2");
      this.connectEditData();
    }
    else{
      this.fetching=false;
    }
  },

  mounted() {
	document.body.classList.add("new-entry");
    this.event_object.event_type = this.$refs.vrstaDogadaja.$data;
    this.event_object.title = this.$refs.naslovDogadaja.$data;
    this.event_object.body = this.$refs.opisDogadaja.$data;
    this.event_object.event_importance = this.$refs.bitnocaDogadaja.$data;
    this.event_object.location_name = this.$refs.lokacijaSastanka.$data;
    this.event_object.online_url = this.$refs.urlLink.$data;
    this.event_object.location_coords = this.$refs.hereMap.$data;
    this.event_object.location_address = this.$refs.hereMap.$data;
    this.event_object.is_online = this.$refs.onlineSastanak.$data;
    this.event_object.all_day = this.$refs.cijeliDan.$data;
    this.event_object.remind_before_minutes = this.$refs.podsjetnik.$data;
    this.event_object.bucket_status = this.$refs.statusDogadaja.$data
    this.generate = this.$refs.generiraj.$data;
    //close anim
    $(".entry-exit").hover(
      function () {
      gsap.to($(this).find("img"), 0.3, {
        rotation: 180,
        transformOrigin: "center",
      });
      },
      function () {
      gsap.to($(this).find("img"), 0.5, {
        rotation: -180,
        transformOrigin: "center",
      });
      }
    );
    $(".hh").blur(function () {
      if ($(this).val() >= 24) $(this).val($(this).val() % 24);

      if ($(this).val() == "") $(this).val("");
      else if ($(this).val() < 10) $(this).val("0" + parseInt($(this).val()));
      var x = $(this).parent().parent().attr("class").split(" ")[1];
      validateTime(x);
    });
    $(".mm").blur(function () {
      if ($(this).val() >= 60) $(this).val($(this).val() % 60);

      if ($(this).val() == "") $(this).val("");
      else if ($(this).val() < 10) $(this).val("0" + parseInt($(this).val()));
      var x = $(this).parent().parent().attr("class").split(" ")[1];
      validateTime(x);
    });

    $(".hh").on("input", function () {
      $(this).parent().parent().removeClass("invalid").removeClass("valid");
      if ($(this).val().length == 2) $(this).siblings(".mm").focus().select();
    });
    $(".mm").on("input", function () {
      $(this).parent().parent().removeClass("invalid").removeClass("valid");
      if ($(this).val().length == 2) $(this).blur();
    });
    $(".hh").on("focus", function () {
      $(this).parent().parent().removeClass("invalid").removeClass("valid");
    });
    $(".mm").on("focus", function () {
      $(this).parent().parent().removeClass("invalid").removeClass("valid");
    });
    function validateTime(x) {
      var t =
        $(".timepicker." + x)
          .find(".hh")
          .val() +
        ":" +
        $(".timepicker." + x)
          .find(".mm")
          .val();
      var isValid = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(t);
      if (isValid) {
        $(".timepicker." + x)
          .removeClass("invalid")
          .addClass("valid");
      } else {
        $(".timepicker." + x)
          .removeClass("valid")
          .addClass("invalid");
      }
    };
    //focus s vrijeme pocetka na zavrsetka
    $("#switch-from").bind("input", function() {
      var $this = $(this);
      setTimeout(function() {
          if ( $this.val().length >= parseInt($this.attr("maxlength"),10) ){
            $('#switch-here').focus();
          }
      },0);
    });

  },
  updated() {
	
  },
  destroyed() {
	  document.body.classList.remove("new-entry");
    $("#switch-from").off();
    $(".hh").off();
    $(".mm").off();
    $(".entry-exit").off();
    $('#pocetak').off();
  },
};
</script>